import { useState } from 'react';
import { SHARING_VARIANT } from 'reactApp/components/SharingWindow/blocks/Weblink/WeblinkList/SharingNewWeblinkList.types';
import { EFrom, SharingTabs } from 'reactApp/components/SharingWindow/Sharing.types';

export const useTabsState = ({
    isSharedIncoming,
    from,
    variant,
}: {
    isSharedIncoming: boolean;
    from: EFrom;
    variant?: SHARING_VARIANT;
}) => {
    const [copiedWeblinkOnMount, setCopiedWeblinkOnMount] = useState(false);
    const [fetchedDataOnMount, setFetchedDataOnMount] = useState(false);

    const [activeTab, setActiveTab] = useState<SharingTabs>(() => {
        if (variant === SHARING_VARIANT.foldersBiz) {
            if (from === EFrom.SHARING) {
                return SharingTabs.CLOUD_USERS_BIZ;
            }
            return SharingTabs.WEBLINK_ACCESS_LIST;
        } else if (isSharedIncoming || from === EFrom.SHARING) {
            return SharingTabs.CLOUD_USERS;
        }

        return SharingTabs.WEBLINK;
    });

    return {
        copiedWeblinkOnMount,
        fetchedDataOnMount,
        activeTab,
        setCopiedWeblinkOnMount,
        setFetchedDataOnMount,
        setActiveTab,
    };
};
